import React, { useEffect, useState } from "react";
import "../../assets/styles/local/DashBoard.css";
import { useDispatch, useSelector } from "react-redux";
import { europeanFormat } from "../../utils/European-Format/NumberFormatter";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const AccountCard = () => {
  const dispatch = useDispatch();
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const last365InvoiceInsights = useSelector((state) => state.user.last365InvoiceInsights);

  useEffect(() => {
    fetchScreenTranslations("BI-Dashboard-List").then(data => setFetchTranslationList(data));
  }, []);

  return (
    <>
      <div className="accountCard accountCard_Res">
        <div className="accountTitle">
          <span>
            {/* Account Payables */}
            {t("Account Payables")}
          </span>
          <span> | </span>
          <span>
            {/* Last 365 Days */}
            {t("Last 365 Days")}
          </span>
        </div>
        <div className="accountDetails">
          <div className="account">
            <text>
              {/* UNPAID */}
              {t("UNPAID")}
            </text>
            <div className="colorline" style={{ color: "#EFCB51" }}></div>
            <div>€ {europeanFormat(last365InvoiceInsights?.spendingsAmount || 0, 0)}</div>
            <text>{last365InvoiceInsights?.spendingsCount || 0} </text>
            <text>
              {/* Documents */}
              {t("Documents")}
            </text>
          </div>
          <div className="cash">
            <text>
              {/* OVERDUE */}
              {t("Unpaid Bills")}
            </text>
            <div className="colorline" style={{ color: "#F76767" }}></div>
            <div>€ {europeanFormat(last365InvoiceInsights?.unpaidBillsAmount || 0, 0)}</div>
            <text>{last365InvoiceInsights?.unpaidBillsCount || 0} </text>
            <text>
              {/* Documents */}
              {t("Documents")}
            </text>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountCard;
